module.exports = __webpack_public_path__ + "static/media/git.69f2a343.jpg";